// SVG-иконка из набора (<IconSprite/> в App)
import { SPRITE, type IconName } from './icons';

export type { IconName } from './icons';

export function Icon({ name, className = '' }: { name: IconName; className?: string }) {
  return (
    <svg className={className ? `i ${className}` : 'i'} aria-hidden="true">
      <use href={`#i-${name}`} />
    </svg>
  );
}

export function IconSprite() {
  return <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" dangerouslySetInnerHTML={{ __html: SPRITE }} />;
}
